import React, {useEffect, useMemo, useRef, useState} from 'react';
import PropTypes from "prop-types";
import Fragment from "common/src/components/widget/Fragment";
import Select from "common/src/components/widget/Select";
import Button from "common/src/components/widget/Button";
import {useTranslation} from "react-i18next";
import FloatingLabelTagsWrapper from "common/src/components/widget/FloatingLabelTagsWrapper";
import {isEqual} from "lodash";

const GroupByColumnsCard = (props) => {

    const {t} = useTranslation();

    const [groupByColumns, setGroupByColumns] = useState(props.formField.value || []);
    const [tempColumn, setTempColumn] = useState("");
    const [externalValue, setExternalValue] = useState(props.formField.value || []);

    const previousGroupByColumns = useRef(props.formField.value || []);

    useEffect(() => {
        if (props.formField.value !== previousGroupByColumns.current) {
            setGroupByColumns(props.formField.value || []);
            setExternalValue(props.formField.value || []);
        }
    }, [props.formField.value]);

    useEffect(() => {
        if (previousGroupByColumns.current !== groupByColumns) {
            previousGroupByColumns.current = groupByColumns;
            if(!isEqual(groupByColumns, externalValue)) {
                console.log("Setting value", groupByColumns, externalValue);
                props.formField.setValue(groupByColumns, undefined, true);
            }
        }
    }, [groupByColumns]);

    // add required columns to group by if user aggregates data
    useEffect(() => {
        if (props.aggregatedColumns.length === 0) {
            return;
        }

        const columnsToIncludeInGroupBy = props.selectedColumns
            .filter((column) => !groupByColumns.includes(column.name) && column.name !== "")
            .map((column) => column.name);

        const distinctGroupByColumns = Array.from(new Set([...columnsToIncludeInGroupBy, ...groupByColumns]));
        setGroupByColumns(distinctGroupByColumns);
    }, [props.aggregatedColumns, props.selectedColumns]);

    const onAdd = () => {
        if (!tempColumn || tempColumn === "\u00A0" || tempColumn === "") {
            return;
        }
        const isUnique = groupByColumns.map((column) => {
            if (column === tempColumn) {
                return false;
            }
        });
        if (isUnique.includes(false)) {
            return;
        }
        setTempColumn("");
        setGroupByColumns([...groupByColumns, tempColumn]);
    }
    const options = useMemo(() => {
        let opt = (props.options || []).slice(); // Create a shallow copy of the array
        opt.sort((a, b) => (a != null && b != null && a.name > b.name) ? 1 : -1);
        return opt;
    }, [props.options]);

    return (
        <div className="card">
            <header className="card-header">
                <p className="card-header-title">
                    <span className="icon fz fz-filter1 medium mr-1"/>
                    <span>{t('dataset.group_by')}</span>
                </p>
            </header>
            <div className="card-content">
                <div>
                    <div className={"grid has-two-columns"}>
                        <FloatingLabelTagsWrapper
                            label={t('data.group_by')}
                            tags={[...groupByColumns]}
                            onTagRemove={ (tag) => {
                                props.formField.setValue(groupByColumns.filter((column) => column !== tag), undefined, true);
                            }
                            }
                            formatter={obj => `${obj}`}
                            disabled={props.disabled}
                            disabledFor={(obj) => props.selectedColumns.find(column => column.name === obj) !== undefined
                                && props.aggregatedColumns.length > 0}
                        />
                    </div>
                    <Fragment rendered={props.options !== undefined && !props.disabled}>
                        <div className={"columns mt-3"}>
                            <div className={"column is-4"}>
                                <Select options={options} optionsCode={"name"} optionsLabel={"name"}
                                        optionsValue={"name"}
                                        selectedItem={tempColumn}
                                        emptyOption={true}
                                        label={t('data.column')}
                                        onChange={(e) => {
                                            setTempColumn(e);
                                        }}/>
                            </div>
                            <div className={"column is-2"}>
                                <Button label={t('add')} className={"is-outlined"}
                                        disabled={props.disabled} onClick={onAdd}/>
                            </div>
                        </div>
                    </Fragment>
                </div>
            </div>
        </div>
    );
}

GroupByColumnsCard.propTypes = {
    options: PropTypes.array,
    formField: PropTypes.object,
    aggregatedColumns: PropTypes.array,
    selectedColumns: PropTypes.array,
    disabled: PropTypes.bool.isRequired
}

GroupByColumnsCard.defaultProps = {
    options: [],
    aggregatedColumns: [],
    selectedColumns: [],
    disabled: false
}

export default GroupByColumnsCard;
